document.addEventListener("DOMContentLoaded", () => {
  const pointBtn = document.querySelector(".point-open");
  const pointText = document.querySelector(".point-text");
  const pointClose = document.querySelector(".point-close");

  pointBtn.addEventListener("click", () => {
    pointText.classList.add("active");
  });

  pointClose.addEventListener("click", () => {
    pointText.classList.remove("active");
  });

  const copyBtns = document.querySelectorAll(".code-btn-row");
  copyBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      var code = btn.previousElementSibling.textContent;
      const copied = btn.nextElementSibling;
      navigator.clipboard.writeText(code);
      btn.classList.add("active");

      setTimeout(function () {
        btn.classList.remove("active");
      }, 3000);
    });
  });

  // Holiday countdown
  const commonGiftImg =
    "https://cdn.shopify.com/s/files/1/0510/7866/0274/files/mdi_gift-outline.webp?v=1764672955";
  const totalDays = document.querySelector(".countdown-pro-list").dataset
    .length;

  const paginationData = Array.from({ length: totalDays }, (_, index) => ({
    img: commonGiftImg,
    text: `Day ${index + 1}`,
  }));

  const countdownProElements = document.querySelectorAll(".countdown-pro");
  var SlideIndex = 0;

  const elementsWithStart = Array.from(countdownProElements).filter((el) => {
    return el.hasAttribute("start");
  });

  if (elementsWithStart.length > 0) {
    const lastElement = elementsWithStart[elementsWithStart.length - 1];
    const lastDataIndex = Number(lastElement.dataset.index);
    SlideIndex = lastDataIndex - 1;
  }

  var countdownSwiper = new Swiper(".countdown-pro-list", {
    slidesPerView: 3,
    spaceBetween: 50,
    initialSlide: SlideIndex,
    centeredSlides: true,
    pagination: {
      el: ".countdown-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        const item = paginationData[index];
        return `
        <div class="${className} custom-pagination-item">
          <img src="${item.img}" alt="${item.text}" class="custom-pagination-img">
          <span class="custom-pagination-text">${item.text}</span>
        </div>
      `;
      },
    },
    navigation: {
      nextEl: ".countdown-next",
      prevEl: ".countdown-prev",
    },
    breakpoints: {
      1300: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 25,
      },
      769: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      0: {
        slidesPerView: 1.3,
        spaceBetween: 16,
      },
    },
  });

  setTimeout(function () {
    const countdownProList = document.querySelectorAll(".countdown-pro");
    const paginationItemList = document.querySelectorAll(
      ".custom-pagination-item"
    );

    countdownProList.forEach((el, index) => {
      const paginationEl = paginationItemList[index];
      el.hasAttribute("start")
        ? paginationEl.classList.add("active")
        : paginationEl.classList.remove("active");
    });
  }, 3000);

  const proBtns = document.querySelectorAll(".countdown-pro-btn.notify-btn");
  const closeBtn = document.querySelector(".close-box-btn");
  const notifyBox = document.querySelector(".notify-box");

  proBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      notifyBox.classList.add("active");
    });
  });

  closeBtn.addEventListener("click", () => {
    notifyBox.classList.remove("active");
  });
});
